'use client';

import { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { fadeInUp } from '@/lib/animations';
import type { AmbassadorContent } from '@/lib/content-schema';

interface Props {
  content: AmbassadorContent['bonusCallout'];
}

export function BonusCallout({ content }: Props) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  return (
    <section className="py-20 md:py-28 bg-zibarit-verde-brillante">
      <motion.div
        ref={ref}
        variants={fadeInUp}
        initial="initial"
        animate={isInView ? 'animate' : 'initial'}
        className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center"
      >
        <svg
          className="w-12 h-12 mx-auto mb-6 text-zibarit-negro/80"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
          />
        </svg>
        <h2 className="text-title text-2xl md:text-3xl lg:text-4xl text-zibarit-negro mb-4">
          {content.title}
        </h2>
        <p className="text-body text-base md:text-lg text-zibarit-negro/80">
          {content.description}
        </p>
      </motion.div>
    </section>
  );
}
